"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceFulfillmentController = void 0;
const gameplay_1 = require("../gameplay");
class ChoiceFulfillmentController {
    constructor(card) {
        this.card = card;
    }
    /**
     * Compare user choices with answer texts from card to see if the choices are fulfilled.
     * @param userChoices string array
     * @returns boolean
     */
    isFulfilled(userChoices) {
        let isFulfilled = false;
        if (userChoices.length === this.card.cardAnswer.answerTexts.length) {
            isFulfilled = true;
        }
        return isFulfilled;
    }
    /**
     * This function should only be used in number gameplay.
     * If true, append the choice to the last element in userChoices array. If false, push the choice as a new element
     * @param userChoices string array
     * @returns boolean
     */
    shouldAppendToLastChoice(userChoices) {
        if (this.card.gameplayInfo.name !==
            gameplay_1.Gameplay.ComposeTheBlankWithLanguageNumberChoicesGameplay001) {
            return false;
        }
        if (userChoices.length === 0) {
            return false;
        }
        if (userChoices.length > this.card.cardAnswer.answerTexts.length) {
            return false;
        }
        const lastChoice = userChoices[userChoices.length - 1];
        const answerTextFromCard = this.card.cardAnswer.answerTexts[userChoices.length - 1];
        if (lastChoice.length < answerTextFromCard.length) {
            return true;
        }
        else {
            return false;
        }
    }
}
exports.ChoiceFulfillmentController = ChoiceFulfillmentController;
